(function () {
  var SPEED = 24;
  var RESUME_DELAY = 900;

  function setup(scroller) {
    if (scroller.getAttribute("data-goat-marquee") === "true") return;
    var track = scroller.querySelector(".m-collection-list__brand-track");
    if (!track || track.children.length < 2) return;
    scroller.setAttribute("data-goat-marquee", "true");

    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    if (!reduceMotion) {
      Array.prototype.forEach.call(track.children, function (node) {
        var copy = node.cloneNode(true);
        copy.setAttribute("aria-hidden", "true");
        Array.prototype.forEach.call(copy.querySelectorAll("a, button"), function (control) {
          control.setAttribute("tabindex", "-1");
        });
        track.appendChild(copy);
      });
    }

    var dragging = false;
    var moved = false;
    var startX = 0;
    var startPosition = 0;
    var position = 0;
    var last = 0;
    var resumeAt = 0;

    function halfWidth() {
      return track.scrollWidth / 2;
    }

    function apply() {
      if (!reduceMotion) {
        var half = halfWidth();
        if (half > 1) {
          position = position % half;
          if (position < 0) position += half;
        }
      }
      scroller.scrollLeft = position;
    }

    function frame(now) {
      if (!last) last = now;
      var dt = Math.min(48, now - last);
      last = now;
      var hovering = finePointer && scroller.matches(":hover");
      var keyboard =
        scroller.matches(":focus-visible") || !!scroller.querySelector(":focus-visible");
      if (!reduceMotion && !dragging && !hovering && !keyboard && now >= resumeAt) {
        position += (SPEED * dt) / 1000;
        apply();
      }
      window.requestAnimationFrame(frame);
    }

    scroller.addEventListener("pointerdown", function (event) {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startPosition = position;
    });

    scroller.addEventListener(
      "pointermove",
      function (event) {
        if (!dragging) return;
        var dx = event.clientX - startX;
        if (!moved && Math.abs(dx) <= 8) return;
        if (!moved) {
          moved = true;
          scroller.classList.add("is-dragging");
          if (scroller.setPointerCapture) {
            try {
              scroller.setPointerCapture(event.pointerId);
            } catch (error) {
              /* The pointer can end before capture. Drag still follows the move events. */
            }
          }
        }
        position = startPosition - dx;
        apply();
        event.preventDefault();
      },
      { passive: false }
    );

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      scroller.classList.remove("is-dragging");
      resumeAt = performance.now() + RESUME_DELAY;
    }

    scroller.addEventListener("pointerup", endDrag);
    scroller.addEventListener("pointercancel", endDrag);
    window.addEventListener("pointerup", endDrag);
    window.addEventListener("pointercancel", endDrag);

    scroller.addEventListener(
      "click",
      function (event) {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      },
      true
    );

    scroller.addEventListener("dragstart", function (event) {
      event.preventDefault();
    });

    window.requestAnimationFrame(frame);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll(".m-collection-list__brand-scroll"), setup);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  document.addEventListener("shopify:section:load", boot);
})();
